module.exports = __webpack_public_path__ + "img/running-free.eb816fe3.jpg";